import React from 'react';
import { Align, FontSize } from '../../modules/ReceiptLayouts/Model';
export const Texto = ({ texto, align, fontSize, bold }) => (React.createElement("p", { style: { lineHeight: '1.2', width: '100%', textAlign: align ? align : defaultProps.align, margin: '0', fontSize: fontSize ? fontSize : defaultProps.fontSize, fontWeight: bold ? 'bold' : 'normal' } }, texto));
const defaultProps = {
    align: Align.Center,
    fontSize: FontSize.normal,
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/Texto.tsx
// module id = 33
// module chunks = 0